/* import __COLOCATED_TEMPLATE__ from './badge.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();